import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-asp-order-instruction-sidebar',
  templateUrl: './asp-order-instruction-sidebar.component.html',
  styleUrls: ['./asp-order-instruction-sidebar.component.scss']
})
export class AspOrderInstructionSidebarComponent implements OnInit {

  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<any>();

  garageDiscount: string = '';
  deliveryMode: string = '';
  notes: string = '';
  maxChars: number = 250;
  instructionData: any = {
    garageDiscount: '',
    deliveryMode: '',
    notes: ''
  };

  constructor(public toastr: ToastrService,) {}

  ngOnInit(): void {

    const savedInstructions = localStorage.getItem('orderInstructions');

    if (savedInstructions) {
      try {

        const parsedData = JSON.parse(savedInstructions);

        this.instructionData = {
          garageDiscount: parsedData.garageDiscount || '',
          deliveryMode: parsedData.preferredDeliveryMode || '',
          notes: parsedData.additionalNotes || ''
        };

      } catch (error) {
        console.error('Error parsing orderInstructions', error);
      }
    }

  }

  get charCount(): number {
    return this.instructionData.notes ? this.instructionData.notes.length : 0;
  }
  
  // close sidebar
  onClose() {
    this.close.emit();
  }

  // skip button
  onSkip() {
    // clear form data
    this.instructionData = {
      garageDiscount: '',
      deliveryMode: '',
      notes: ''
    };

    // remove saved localStorage data
    localStorage.removeItem('orderInstructions');

    this.close.emit();
  }
  // save button
 onSave() {
  const { garageDiscount, deliveryMode, notes } = this.instructionData;

  if (!garageDiscount && !deliveryMode && !notes?.trim()) {
    this.toastr.error('Please fill at least one field', 'Error');
    return;
  }

  const dataToSave = {
    garageDiscount: garageDiscount ? Number(garageDiscount) : 0.0,
    preferredDeliveryMode: deliveryMode || '',
    additionalNotes: notes?.trim() || ''
  };

  // ✅ always store ONLY JSON
  localStorage.setItem('orderInstructions', JSON.stringify(dataToSave));

  // 🔥 emit structured data instead of string (important)
  this.save.emit(dataToSave);

  this.close.emit();
}

  // format for Zoho
  getFormattedInstructions(): string | null {
    const parts: string[] = [];

    if (this.instructionData.garageDiscount) {
      parts.push(`Garage Discount %: ${this.instructionData.garageDiscount}`);
    }

    if (this.instructionData.deliveryMode) {
      parts.push(`Preferred Delivery Mode: ${this.instructionData.deliveryMode}`);
    }

    if (this.instructionData.notes) {
      parts.push(`Additional Notes: ${this.instructionData.notes}`);
    }

    return parts.length ? parts.join(' | ') : null;
  }

  // limit textarea manually (safety)
  onNotesChange(value: string) {
    if (value.length > this.maxChars) {
      this.notes = value.substring(0, this.maxChars);
    }
  }
  
}